import React, { createContext, useContext, useState, useEffect } from 'react';

// Estados do Sidebar do Maker (similar ao menu principal)
export const SIDEBAR_STATES = {
  EXPANDED: 'expanded',
  COLLAPSED: 'collapsed', 
  HIDDEN: 'hidden'
};

const MakerContext = createContext();

export const useMaker = () => {
  const context = useContext(MakerContext);
  if (!context) {
    return {
      sidebarState: SIDEBAR_STATES.EXPANDED,
      sidebarCollapsed: false,
      sidebarCompact: false,
      handleToggleSidebar: () => {},
      handleToggleCompact: () => {},
      handleCycleSidebarState: () => {},
      handleCreateNew: () => {},
      newViewOptions: [],
      isMakerPage: false
    };
  }
  return context;
};

export const MakerProvider = ({ children }) => {
  // Novo estado unificado do sidebar (expanded, collapsed, hidden)
  const [sidebarState, setSidebarState] = useState(() => {
    const saved = localStorage.getItem('maker-sidebar-state');
    return Object.values(SIDEBAR_STATES).includes(saved) ? saved : SIDEBAR_STATES.EXPANDED;
  });

  // Mantém compatibilidade com estados antigos
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    return localStorage.getItem('maker-sidebar-collapsed') === 'true';
  });

  const [sidebarCompact, setSidebarCompact] = useState(() => {
    return localStorage.getItem('maker-sidebar-compact') === 'true';
  });

  const [handleCreateNew, setHandleCreateNew] = useState(() => () => {});
  const [newViewOptions, setNewViewOptions] = useState([]);

  // Cicla entre os 3 estados: expanded -> collapsed -> hidden -> expanded
  const handleCycleSidebarState = () => {
    setSidebarState(prev => {
      const states = [SIDEBAR_STATES.EXPANDED, SIDEBAR_STATES.COLLAPSED, SIDEBAR_STATES.HIDDEN];
      const currentIndex = states.indexOf(prev);
      const nextIndex = (currentIndex + 1) % states.length;
      const nextState = states[nextIndex];
      localStorage.setItem('maker-sidebar-state', nextState);
      return nextState;
    });
  };

  // Mantém handlers antigos para compatibilidade
  const handleToggleSidebar = () => {
    setSidebarCollapsed(prev => {
      const newValue = !prev;
      localStorage.setItem('maker-sidebar-collapsed', newValue);
      return newValue;
    });
  };

  const handleToggleCompact = () => {
    setSidebarCompact(prev => {
      const newValue = !prev;
      localStorage.setItem('maker-sidebar-compact', newValue);
      return newValue;
    });
  };

  const value = {
    // Novo sistema de estados
    sidebarState,
    setSidebarState,
    handleCycleSidebarState,
    SIDEBAR_STATES,
    // Compatibilidade com sistema antigo
    sidebarCollapsed,
    sidebarCompact,
    handleToggleSidebar,
    handleToggleCompact,
    setSidebarCollapsed,
    setSidebarCompact,
    handleCreateNew,
    setHandleCreateNew,
    newViewOptions,
    setNewViewOptions
  };

  return (
    <MakerContext.Provider value={value}>
      {children}
    </MakerContext.Provider>
  );
};
